import { post } from '../utils/api/api'

/**
 * Фиксированный словарь имён метрик для POST /metrics/events.
 * Имя уходит в Prometheus как есть, поэтому строить его из ID или
 * пользовательского ввода нельзя — только из этого словаря.
 */
export const METRIC_EVENTS = {
  // Мост не выдал токен, но сохранённый игровой ключ на месте — сторона магазина
  AUTH_WINDOW_SHOWN_GAME_TOKEN_STORED: 'auth_window_shown_game_token_stored_total',
  // Нет ни игровых, ни екомовых следов — хранилище WebView стёрто целиком
  AUTH_WINDOW_SHOWN_NO_SIGNALS: 'auth_window_shown_no_signals_total',
  // Гость (знаменатель, не перелогин)
  AUTH_WINDOW_SHOWN_GUEST: 'auth_window_shown_guest_total',
  // Reload приложения — общий счётчик и разбивка по причине вызова
  APP_RELOAD_TOTAL: 'app_reload_total',
  APP_RELOAD_CRITICAL_ERROR: 'app_reload_critical_error_total',
  APP_RELOAD_OFFLINE_RETRY: 'app_reload_offline_retry_total',
  APP_RELOAD_GAME_END_NETWORK_ERROR: 'app_reload_game_end_network_error_total',
}

// Fire-and-forget: сбой телеметрии не должен ломать UX
export function recordMetricEvent(name, { type = 'counter', value = 1 } = {}) {
  return post('/metrics/events', { name, type, value }, { skipDeduplication: true }).catch(() => {})
}
